export default __webpack_public_path__ + "static/media/btn_delete.5b5ac736.svg";